import Helpers from './../Helpers'

const address = document.querySelector('.form-section--postal-address')

if (address !== null) {
    const countryDDL = document.querySelector('.form-section--postal-address .address-part--country select')
    const county = document.querySelector('.form-section--postal-address .address-part--county')
    const state = document.querySelector('.form-section--postal-address .address-part--usstate')
    const postcodeFinder = document.querySelector('.form-section--postal-address .form-field--finder')
    const postcode = document.querySelector('.form-section--postal-address .address-part--postcode')

    const updateLayout = () => {
        new Helpers(county).setAttributes({ 'aria-hidden': countryDDL.value === 'US' })
        new Helpers(state).setAttributes({ 'aria-hidden': countryDDL.value !== 'US' })
        new Helpers(postcodeFinder).setAttributes({ 'aria-hidden': countryDDL.value !== 'GB' })
        postcode.querySelector('label').innerText = countryDDL.value === 'US' ? 'Zipcode' : 'Postcode'

        if (address.getAttribute('data-required') === 'true') {
            const countryHasPostcode = countryDDL.querySelector(`option[value="${countryDDL.value}"]`).getAttribute('data-postcode') === 'true'
            if (countryHasPostcode) {
                new Helpers(postcode.querySelector('input')).setAttributes({ required: 'required', 'aria-required': 'true' })
                new Helpers(postcode.querySelector('label')).addClass('form-label--required')
            } else {
                new Helpers(postcode.querySelector('input')).removeAttributes(['required', 'aria-required'])
                new Helpers(postcode.querySelector('label')).removeClass('form-label--required')
            }
        }
    }

    new Helpers(countryDDL).eventListener(updateLayout, 'change')

    updateLayout()
}
